<template>
  <v-dialog v-model="dialog" persistent width="400" scrollable>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title> {{ header }} Selector </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-list dense class="ma-0 pa-0 mt-2">
        <v-text-field
          label="Search"
          v-model="search"
          dense
          outlined
          class="mx-1"
        ></v-text-field>

        <v-divider></v-divider>

        <v-list-item-group
          v-model="selectedItem"
          active-class="__selected-item"
        >
          <v-list-item
            v-for="(item, idx) in filteredList"
            :value="item"
            :key="idx"
          >
            {{ item.title }}
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- <v-card-text class="mt-2">
      </v-card-text> -->

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="submit"> submit </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      callback: null,
      step: null,
      listItems: [],
      selectedItem: null,
      search: "",
      modules: null,
      header: "",
      controller: null,
    };
  },
  computed: {
    filteredList() {
      let self = this;
      let searchTerm = self.search.toLowerCase();

      if (self.listItems == null) {
        return [];
      }

      return self.listItems.filter((q) => {
        return q.title.includes(searchTerm);
      });
    },
  },
  methods: {
    getListItems(step, systemCode) {
      let self = this;
      self
        .get(`${systemCode}/GetAll`)
        .then((r) => {
          self.listItems = r.data.data;

          if (step != null && step.moduleRefId > 0) {
            var item = self.listItems.find((q) => {
              return q.id == step.moduleRefId;
            });

            self.selectedItem = item;
          }
        })
        .catch((err) => {
          console.error(`unable to get ${this.systemCode}`, err);
        });
    },
    show(callback, step, systemCode, controller) {
      let self = this;
      self.callback = callback;
      self.step = step;
      self.dialog = true;
      self.systemCode = systemCode;
      self.controller = controller;
      this.modules = this.systemModules[
        this.$route.params.systemCode
      ].getAllowedModules();
      let module = this.modules.find((x) => x.systemCode == systemCode);
      if (module != undefined) {
        self.header = module.name;
      } else {
        self.header = systemCode;
      }
      self.getListItems(step, systemCode);
    },
    submit() {
      let self = this;
      console.log(self.callback);
      self.controller[self.callback](self.selectedItem, self.step);
      self.dialog = false;
    },
  },
};
</script>

<style>
.__selected-item {
  color: blue;
}
</style>